module.exports = __webpack_public_path__ + "static/img/tcode.88fd5960.jpg";